import React from 'react';
import { Result, Button } from 'antd';
import { Link } from 'react-router-dom';
import { useQueryParams } from 'hooks';

const email = process.env.REACT_APP_PMS_ADMIN_EMAIL;

const UserDepartmentNotFound = () => {
  const department = useQueryParams()?.get('department');
  const subject = `User department [${department}] not found in PMS`;

  const handleOnClick = (e) => {
    window.location.href = `mailto:${email}?subject=${subject}`;
    e.preventDefault();
  };

  return (
    <Result
      className="standalone-result-page"
      status="warning"
      title="There are some problem when logining your account"
      subTitle={<p>Please contact PMS administrator.</p>}
      extra={[
        <Link to="#" onClick={handleOnClick}>
          <Button type="primary">Contact PMS administrator</Button>
        </Link>,
        <Button>
          <Link to="/login">Go back to Login</Link>
        </Button>,
      ]}
    />
  );
};

export default UserDepartmentNotFound;
